// ProviderIcons.js
const ProviderIcons = ({ providers }) => {
  return (
    <div className="provider-icons-container">
      {providers.map(provider => {
        const imageName = provider.toLowerCase().replace(/ /g, '-');
        const imagePath = process.env.PUBLIC_URL + `/static/img/providers/${imageName}.jpeg`;
        return (
          <img
            key={provider}
            src={imagePath}
            alt={provider}
            title={provider}
            className="provider-icon large-icon"
            onError={(e) => e.target.style.display = 'none'}
          />
        );
      })}
    </div>
  );
};

export default ProviderIcons;
